import { Icon, IconButton } from '@atom/mui';
import { HelpIcon } from '@atom/mui/icons';

import classes from './workTemplateSettings.module.css';

const styles = {
  helpIconButton: {
    width: '1.25rem',
    height: '1.25rem',
  },
  helpIcon: {
    fontSize: '1.25rem',
  },
};

const SettingsTitle = () => {
  const tooltipContent = (
    <div className={classes.settingsTooltip}>
      <div className={classes.settingsTooltipRow}>
        <div>&bull;</div>
        <div className={classes.settingsTooltipContent}>
          When a section is enabled, the child work template must inherit the
          content in that section as it appears on the parent without permission
          to modify the inherited content.
        </div>
      </div>
      <div className={classes.settingsTooltipRow}>
        <div>&bull;</div>
        <div className={classes.settingsTooltipContent}>
          When a section is disabled, the child work template will not inherit
          any content from that section.
        </div>
      </div>
      <div className={classes.settingsTooltipRow}>
        In both scenarios, the child work template can add additional fields,
        files, or items to any of the sections.
      </div>
    </div>
  );

  return (
    <div className={classes.headerContainer}>
      <div className={classes.title}>Child Work Template Settings</div>
      <IconButton
        style={styles.helpIconButton}
        tooltip={tooltipContent}
        lightTooltip
        TooltipProps={{
          placement: 'bottom-end',
        }}
      >
        <Icon style={styles.helpIcon} icon={HelpIcon} />
      </IconButton>
    </div>
  );
};

export default SettingsTitle;
